class ReportingEquipmentInfoServiceHistoryController {
    constructor($ngRedux) {
        this.$ngRedux = $ngRedux;
    }

    $onInit() {
        this.unsubscribe = this.$ngRedux.connect(this.mapState, {})(this);
    }

    $onDestroy() {
        this.unsubscribe();
    }

    mapState(state) {
        return {
            equipment: state.reporting.reportingEquipmentDetails
        }
    }
}

ReportingEquipmentInfoServiceHistoryController.$inject = ['$ngRedux'];

export const reportingEquipmentInfoServiceHistory = {
    controller: ReportingEquipmentInfoServiceHistoryController,
    template: `
        <reporting-equipment-info-service-history-grid title="{{$ctrl.equipment.title}}"></reporting-equipment-info-service-history-grid>
        <tabs-navigation identifier="app.reporting.equipmentInfo"
                         state="app.reporting.equipmentInfo.serviceHistory">
        </tabs-navigation>
    `
};
